"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_TERM_KEY = exports.ANG_TYPE = exports.INNER_HITS_KEY = exports.HIGHLIGHT_KEY = exports.SCORE_KEY = exports.SOURCE_KEY = void 0;
exports.SOURCE_KEY = '_source';
exports.SCORE_KEY = '_score';
exports.HIGHLIGHT_KEY = 'highlight';
exports.INNER_HITS_KEY = 'inner_hits';
exports.ANG_TYPE = '@type';
exports.SEARCH_TERM_KEY = 'searchTerm';
